import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Variations page filters (client state). Mirrors postsStore.filters for the Creator:
 * survives navigation within the session, reset via clearFilters.
 */
export interface VariationFilters {
  search: string;
  type: 'all' | 'language' | 'custom';
  status: 'all' | 'DRAFT' | 'READY';
  language: string;
  workflowStatus: string;
  /** Comma-separated labels (same shape as postsStore `tags`) */
  labels: string;
}

export const DEFAULT_VARIATION_FILTERS: VariationFilters = {
  search: '',
  type: 'all',
  status: 'all',
  language: 'all',
  workflowStatus: 'all',
  labels: '',
};

interface VariationsFilterStore {
  filters: VariationFilters;
  setFilter: (key: string, value: string) => void;
  clearFilters: () => void;
}

export const useVariationsFilterStore = create<VariationsFilterStore>()(
  devtools(
    (set) => ({
      filters: DEFAULT_VARIATION_FILTERS,
      setFilter: (key, value) =>
        set((state) =>
          key in state.filters
            ? { filters: { ...state.filters, [key]: value } }
            : state
        ),
      clearFilters: () => set({ filters: DEFAULT_VARIATION_FILTERS }),
    }),
    { name: 'VariationsFilterStore', enabled: import.meta.env.DEV }
  )
);
